<app-sidebar [class.is-shown]="isSidebarShown" class="z-1"></app-sidebar>
<button
  class="btn btn-outline-secondary btn-sm sidebar-toggle"
  title="Toggle sidebar"
  (click)="isSidebarShown = !isSidebarShown">
  <i class="fa fa-bars"></i>
</button>
<main class="z-0">
  <div class="flex flex-col">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</main>
<p-toast />
<p-confirmdialog />
